'use strict';

var _ = require('lodash');
var ReinitializationService = function ReinitializationService(restangular, configurationService, momentService, hepService) {
  var DEMAND_OVERRIDE_ROUTE_DOMAIN = 'DEMAND_PROFILE_OVERRIDE';
  var demandService = restangular.service('domain/flights/demandReinitialization');
  var showUpService = restangular.service('domain/flights/showUpReinitialization');
  var externalOverrideCountService = restangular.one('queue/InterfaceServerProcessingQueue/count');
  var directForecastRequestMessages = restangular.one('queue/DirectForecastWorkload/messages');
  var olapLambdaRequestMessages = restangular.one('queue/OlapLambdaTriggerRequest/messages');
  var demandReinitializationMessages = restangular.one('queue/DemandInitWorkload/messages');
  var DEFAULT = 'Default';
  function reinitializeRequest(rows, calendarMode, screenMode, allowReadingForecastTypeFromRow) {
    return reinitialize(prepareRequestParams(rows, screenMode, calendarMode, allowReadingForecastTypeFromRow), calendarMode);
  }
  function reinitialize(requestParams, calendarMode) {
    return calendarMode === 'Demand' ? demandService.post(requestParams) : showUpService.post(requestParams);
  }
  function generateCalendarName(calendarMode, screenMode, row) {
    var adminCalendarName = calendarMode === 'Demand' ? 'ReinitDmd' : 'ReInitShowup';
    return screenMode === 'Admin' ? adminCalendarName : row.calendarName;
  }
  function getForecastType(row, allowReadingForecastTypeFromRow) {
    if (allowReadingForecastTypeFromRow) {
      return row.forecastType || 'Market';
    }
    var predicate = {
      origin: row.origin,
      destination: row.destination
    };
    var market = _.filter(configurationService.getMarkets(), predicate);
    if (market.length > 0) {
      return market[0].forecastType || 'Market';
    }
    return 'Market';
  }
  function prepareRequestParams(preparedData, screenMode, calendarMode, allowReadingForecastTypeFromRow) {
    var requestParams = {
      queueElements: []
    };
    _.forEach(preparedData, function (row) {
      var incomingQueueElements = {
        marketOrigin: row.origin,
        marketDestination: row.destination,
        startDepartureDate: row.startDepartureDate.toISOString(),
        endDepartureDate: row.endDepartureDate ? row.endDepartureDate.toISOString() : momentService.now(momentService.FIELD.DEPARTURE_DATE).toISOString(),
        carrier: configurationService.getHostCarrier(),
        calendarName: generateCalendarName(calendarMode, screenMode, row),
        triggeredFrom: row.triggeredFrom ? row.triggeredFrom : '',
        dowGroupflag: false
      };
      if (row.dowGroupFlag) {
        incomingQueueElements.dowGroupflag = row.dowGroupFlag;
      }
      if (calendarMode === 'Demand') {
        incomingQueueElements.forecastType = getForecastType(row, allowReadingForecastTypeFromRow);
        incomingQueueElements.clearDemandAdjsFlag = row.clearDemandAdjsFlag ? row.clearDemandAdjsFlag : false;
      }
      requestParams.queueElements.push(incomingQueueElements);
    });
    return requestParams;
  }
  function countExternalOverridesInProgress() {
    var filter = {
      filter: 'acknowledge=exists=false;events.destinationRouteDomain==\'' + DEMAND_OVERRIDE_ROUTE_DOMAIN + '\''
    };
    return externalOverrideCountService.get(filter).then(function (data) {
      return data;
    });
  }
  function getPendingMarketsFromQueue(queueMessages) {
    var markets = [];
    var messages = queueMessages.plain();
    for (var messageIndex in messages) {
      var queueMessage = messages[messageIndex];
      for (var eventIndex in queueMessage.events) {
        var event = queueMessage.events[eventIndex];
        var eventType = _.get(event, 'initializationType');
        if (queueMessage.queue === 'DemandInitWorkload' || queueMessage.queue === 'DirectForecastWorkload') {
          if (eventType === 'REINITIALIZATION') {
            markets.push([event.marketOrigin, event.marketDestination].join('-'));
          }
        } else if (queueMessage.queue === 'OlapLambdaTriggerRequest') {
          var queueMarkets = _.chain(event).get('input.markets', []).map('market').value();
          markets = _.concat(markets, queueMarkets);
        }
      }
    }
    return _.uniq(markets);
  }
  function getDemandReinitializationOnProgressMarkets() {
    var queryString = {
      filter: 'acknowledge=exists=false'
    };
    return demandReinitializationMessages.get(queryString).then(getPendingMarketsFromQueue);
  }
  function getDirectForecastWorkloadPendingMarkets() {
    var queryString = {
      filter: 'acknowledge=exists=false'
    };
    return directForecastRequestMessages.get(queryString).then(getPendingMarketsFromQueue);
  }
  function getOlapLambdaRequestPendingMarkets() {
    var queryString = {
      filter: 'acknowledge=exists=false'
    };
    return olapLambdaRequestMessages.get(queryString).then(getPendingMarketsFromQueue);
  }
  function isDemandSmoothingAlphaAboveZero(markets) {
    return hepService.getHepByType('DemandSmoothingAlpha').then(function (hepResponseData) {
      var marketToHepMap = hepResponseData.hepList.reduce(function (map, obj) {
        var origin = obj.attributes.origin;
        var destination = obj.attributes.destination;
        var isDefault = !!origin === false || !!destination === false;
        map[isDefault ? DEFAULT : origin + '-' + destination] = obj;
        return map;
      }, {});
      for (var i = 0; i < markets.length; ++i) {
        var market = markets[i];
        if (market.forecastType !== 'Market') {
          continue;
        }
        var marketStr = market.origin + '-' + market.destination;
        var hepForGivenMarket = marketToHepMap[marketStr];
        if (hepForGivenMarket) {
          if (hepForGivenMarket.properties.alpha === 0) {
            return marketStr;
          }
        } else if (marketToHepMap[DEFAULT].properties.alpha === 0) {
          return 'all';
        }
      }
      return true;
    });
  }
  return {
    reinitializeRequest: reinitializeRequest,
    countExternalOverridesInProgress: countExternalOverridesInProgress,
    getDirectForecastWorkloadPendingMarkets: getDirectForecastWorkloadPendingMarkets,
    getDemandReinitializationOnProgressMarkets: getDemandReinitializationOnProgressMarkets,
    getOlapLambdaRequestPendingMarkets: getOlapLambdaRequestPendingMarkets,
    isDemandSmoothingAlphaAboveZero: isDemandSmoothingAlphaAboveZero
  };
};
ReinitializationService.$inject = ['Restangular', 'ConfigurationService', 'MomentService', 'HepService'];
module.exports = ReinitializationService;